export default "/images/756294aa7bc386e4e191eed9ed9cf1c3.avif";